import React from "react";
import { useSelector } from 'react-redux'
import {
  DataTable, Table, TableBody, TableCell, TableContainer,
  TableHead, TableHeader, TableRow, TableToolbar, TableToolbarContent,
  TableToolbarSearch
} from '@carbon/react';
import { useSorting } from "../../../modules/hooks/sorting";

const ChargingTimeTable = _ => {
  const { table } = useSelector(state => state.charging)

  const headerData = [
    {
      header: 'Punto de Carguío',
      key: 'lugar_carga',
    },
    {
      header: 'Fecha / Hora Término',
      key: 'event_time_max',
      sortDirection: "DESC",
      isDefaultSortable: true
    },
    {
      header: 'Duración de Carga (minutos)',
      key: 'time_diff_sum',
      sortDirection: "DESC",

    }
  ];
  const { headers, rows } = useSorting(table, headerData);

  const Default = () => <DataTable rows={rows} headers={headers} width="100%">
    {({
      rows,
      headers,
      getHeaderProps,
      getRowProps,
      getTableProps,
      getTableContainerProps,
      onInputChange,
      sortBy
    }) => <TableContainer {...getTableContainerProps()}>
        <TableToolbar>
          <TableToolbarContent>
            {/* pass in `onInputChange` change here to make filtering work */}
            <TableToolbarSearch onChange={onInputChange} />
          </TableToolbarContent>
        </TableToolbar>
        <Table {...getTableProps()} aria-label="sample table">
          <TableHead>
            <TableRow>
              {headers.map((header, i) => {
                const { key: _unusedKey, ...headerProps } = getHeaderProps({
                  header,
                  isSortable: (headerData[i]?.sortDirection ?? "NONE") !== "NONE",
                  onClick: (_, sortState) => sortBy(sortState.sortHeaderKey),
                });

                return (
                  <TableHeader
                    key={i}
                    sortDirection={headerData[i]?.sortDirection ?? "NONE"}
                    {...headerProps}
                  >
                    {header.header}
                  </TableHeader>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => {
              const { key: _unusedKey, ...rowProps } = getRowProps({ row });

              return (
                <React.Fragment key={row.id}>
                  <TableRow {...rowProps}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>{cell.value}</TableCell>
                    ))}
                  </TableRow>
                </React.Fragment>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>}
  </DataTable>;

  return (
    <Default />
  )
}

export default ChargingTimeTable